import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'

export default class Question extends Entity {
  public text = ''
  public competenceId = ''
  public sortIndex = 0
}
